import { Card, Col } from "react-bootstrap";
import { User, Phone } from "lucide-react";

export const SheriffCards = ({ name, phone, foreclosureLabel, foreclosurePhone }) => {
  const sheriffTel = phone?.replace(/[^\d+]/g, "");
  const foreclosureTel = foreclosurePhone?.replace(/[^\d+]/g, "");

  return (
    <>
      <Col md={6}>
        <Card className="softCard h-100 w-100">
          <Card.Body className="d-flex gap-3">
            <User size={22} className="orange" />
            <div>
              <div className="text-secondary fw-medium">Sheriff</div>
              <div className="fs-8">{name}</div>
              {foreclosurePhone && phone && (
                <a href={`tel:${sheriffTel}`} className="text-decoration-none orange">
                  {phone}
                </a>
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col md={6}>
        <Card className="softCard h-100 w-100">
          <Card.Body className="d-flex gap-3">
            <Phone size={22} className="orange" />
            <div>
              {foreclosurePhone ? (
                <>
                  <div className="text-secondary fw-medium">{foreclosureLabel}</div>
                  <a href={`tel:${foreclosureTel}`} className="text-decoration-none orange">
                    {foreclosurePhone}
                  </a>
                </>
              ) : (
                <>
                  <div className="text-secondary fw-medium">Sheriff's Office</div>
                  {phone && (
                    <a href={`tel:${sheriffTel}`} className="text-decoration-none orange">
                      {phone}
                    </a>
                  )}
                </>
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};